import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { formatDate, formatToZMW, numberToWords, rootUrl, sumOfArray } from "../helpers";
import { useAuth } from "../context/auth-context";

const Receipt = React.forwardRef(({data}, ref) => {

    const {allData, setAllData} = useOutletContext();

    const auth = useAuth()

    const {cheque,
        date,
        voucher,
        paye,
        amount,
        paymentMethod="Bank",
        description,
        updatedBy,
        receivedBy = {},
        issuedBy = {},
        bankDetails = {
          bankName: "",
          accountNo: "",
        }} = data[0]

    
      const user = allData.users?.find(a=>a.u_id == updatedBy)
      const preparer = `${user?.firstname} ${user?.lastname}`
      const [issuer, setIssuer] = useState({})
      useEffect(()=>{

        setIssuer({
          name:preparer,
          signature:'',
          date:formatDate(date)
        })
        

      },[])
         data.issuedBy = {
                name:preparer,
                signature:'',
                date:formatDate(date)
              }

              const [allneeded, setAllneeded] = useState([])

              useEffect(()=>{
                setAllneeded(data)
              },[])

               const renderBudgetDetails = () => {
                  return (
                    <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm mb-4">
                      <thead>
                        <tr className="bg-gray-200">
                          <th className="border px-2 py-1">Programme</th>
                          <th className="border px-2 py-1">Sub Program</th>
                          <th className="border px-2 py-1">Chart of Accounts</th>
                          <th className="border px-2 py-1">Description</th>
                          <th className="border px-2 py-1">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allneeded.filter(a=>a.type == 'income').map((row, index) => {
                          const bItems = allData.budget?.filter(
                            (budget) => budget.id == row.coa_id
                          )[0]
                          return(
                            <tr key={index} className="text-center">
                          
                            <td className="border px-2 py-1">
                              {allData.program?.find(
                                (a) => a.programCode === bItems?.program
                              )?.name || ""}
                            </td>
                            <td className="border px-2 py-1">
                             
                              {allData.coa?.find(
                                (a) => parseInt(a.account) == parseInt(bItems?.coa))?.name}
                            </td>
                            <td className="border px-2 py-1">{bItems?.coa}</td>
                            <td className="border px-2 py-1 text-left whitespace-pre-wrap break-words">
                              {row?.description || row?.desc || ""}
                            </td>
                            <td className="border px-2 py-1">
                              {/* {formatToZMW(row.price * row.frequency * row.qty)} */}
                              {formatToZMW(row?.amount)}
                            </td>
                          </tr>
                          )
                        })}
              
                        <tr>
                          <th className="border px-2 py-1" colSpan={4}>
                            Total
                          </th>
                          <th className="border px-2 py-1">
                            {formatToZMW(sumOfArray(allneeded.filter(a=>a.type == 'income').map(res=>parseFloat(res?.amount))))}
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  );
                };

  return (
    <div ref={ref} className="border border-gray-500 p-4 w-[800px] mx-auto rounded-lg">
      <header className="flex flex-col items-center justify-center text-center gap-2 mb-2">
        <img
          className="block w-[150px] h-[150px] object-contain mx-auto"
          src={rootUrl(`/${allData?.council[0]?.path}`)}
          alt=""
        />
        <h2 className="text-2xl font-semibold text-gray-900 w-full">
          {allData?.council[0]?.name}
        </h2>
        <p className="text-2xl font-semibold text-gray-900 tracking-wide">RECEIPT</p>
      </header>
      
      <div className="flex justify-between items-start my-4">
        <div>
          <p>RECEIPT NO.: {voucher}</p>
          <p>DATE: {formatDate(date)}</p>
        </div>
        <div className="mb-4">
        <p>
          
          <span>CUSTOMERS:</span> {allData.suppliers?.find(a=>a.id == paye)?.name}
        </p>
        <p>
          <span>PAYMENT METHOD:</span> {paymentMethod}
        </p>
      </div>
      </div>

      
      

      {/* Description of Payment */}
      {/* <div className="mb-4">
        <p className="font-semibold">DESCRIPTION OF PAYMENT:</p>
        <p className="h-12 border border-gray-300 p-2">
          {description}
        </p>
      </div> */}

      {/* Amount in Words */}

      <div className="mb-4">
        <p className="font-semibold">AMOUNT:</p>
        <p className="h-8 border border-gray-300 p-2"> 
           {numberToWords(sumOfArray(allneeded.filter(a=>a.type == 'income').map(res=>parseFloat(res.amount))))} Kwacha
           </p>
      </div>

      {renderBudgetDetails()}

      {/* Bank Details */}
      {bankDetails.bankName && (
        <div className="mb-4">
          <p>
            <span className="font-semibold">BANK NAME:</span>{" "}
            {bankDetails.bankName}
          </p>
          <p>
            <span className="font-semibold">ACCOUNT NO:</span>{" "}
            {bankDetails.accountNo}
          </p>
        </div>
      )}

      {/* Signatures */}
      <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
        {/* Received By */}
        <div className="border p-2">
          <p className="font-semibold">RECEIVED BY</p>
          <p>Name: {receivedBy.name}</p>
          <p>Signature: {receivedBy.signature}</p>
          <p>Date: {receivedBy.date}</p>
        </div>

        {/* Issued By */}
        <div className="border p-2">
          <p className="font-semibold">ISSUED BY</p>
          <p>Name: {issuer?.name}</p>
          <p>Signature: {issuer?.signature}</p>
          <p>Date: {issuer?.date}</p>
        </div>
      </div>

      {/* Footer Note */}
      <p className="text-xs mt-4">
        NOTE: This is an official receipt. Please retain it for your records.
      </p>
    </div>
  );
});

export default Receipt;
